import { CenterGroup } from '../../../lib/types/models/center-group/center-group'
import { CenterGroupInput } from '../../../lib/types/models/center-group/center-group-input'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function updateCenterGroup(
  input: Partial<CenterGroupInput> & { centerId: number; groupId: number }
) {
  const { centerId, groupId, ...rest } = input
  return restApiClient
    .url(constructApiUrl(API.centers.updateCenterGroup.url, { id: centerId, groupId }))
    .patch<CenterGroup, Partial<CenterGroupInput>>(rest)
}
